module.exports = __webpack_public_path__ + "img/TakeBack_icon.686c89f0.png";